
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/reports",
      function () {
        return require("private-next-pages/investor/reports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/reports"])
      });
    }
  